import { render, staticRenderFns } from "./RolesSettingsMain.vue?vue&type=template&id=d7e95be8&scoped=true&"
import script from "./RolesSettingsMain.vue?vue&type=script&lang=js&"
export * from "./RolesSettingsMain.vue?vue&type=script&lang=js&"
import style0 from "./RolesSettingsMain.vue?vue&type=style&index=0&id=d7e95be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e95be8",
  null
  
)

export default component.exports